/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateAwsKmsKeyRequestBody,
  UpdateAwsKmsKeyRequestBody$Outbound,
  UpdateAwsKmsKeyRequestBody$outboundSchema,
} from "../components/updateawskmskeyrequestbody.js";

export type UpdateAwsKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateAwsKmsKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateAwsKmsKeyRequestBody: UpdateAwsKmsKeyRequestBody;
};

/** @internal */
export type UpdateAwsKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateAwsKmsKeySecurity$outboundSchema: z.ZodMiniType<
  UpdateAwsKmsKeySecurity$Outbound,
  UpdateAwsKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateAwsKmsKeySecurityToJSON(
  updateAwsKmsKeySecurity: UpdateAwsKmsKeySecurity,
): string {
  return JSON.stringify(
    UpdateAwsKmsKeySecurity$outboundSchema.parse(updateAwsKmsKeySecurity),
  );
}

/** @internal */
export type UpdateAwsKmsKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateAwsKmsKeyRequestBody: UpdateAwsKmsKeyRequestBody$Outbound;
};

/** @internal */
export const UpdateAwsKmsKeyRequest$outboundSchema: z.ZodMiniType<
  UpdateAwsKmsKeyRequest$Outbound,
  UpdateAwsKmsKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateAwsKmsKeyRequestBody: UpdateAwsKmsKeyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateAwsKmsKeyRequestBody: "UpdateAwsKmsKeyRequestBody",
    });
  }),
);

export function updateAwsKmsKeyRequestToJSON(
  updateAwsKmsKeyRequest: UpdateAwsKmsKeyRequest,
): string {
  return JSON.stringify(
    UpdateAwsKmsKeyRequest$outboundSchema.parse(updateAwsKmsKeyRequest),
  );
}
